import { State as RequestState } from '@occc-app/Offer/components/PageableRequest';
import { RequestOptions } from '@occc-app/lib/constants';

const REQUEST_OFFERS = 'app/Offers/REQUEST_OFFERS';
const OFFERS_OK = 'app/Offers/OFFERS_OK';
const OFFERS_ERR = 'app/Offers/OFFERS_ERR';
const CHANGE_PATH = 'app/Offers/CHANGE_PATH';
const UPDATE_FILTER = 'app/Offers/UPDATE_FILTER';

type Types = {
  REQUEST_OFFERS: typeof REQUEST_OFFERS;
  OFFERS_OK: typeof OFFERS_OK;
  OFFERS_ERR: typeof OFFERS_ERR;
  CHANGE_PATH: typeof CHANGE_PATH;
  UPDATE_FILTER: typeof UPDATE_FILTER;
};

const types: Types = {
  REQUEST_OFFERS,
  OFFERS_OK,
  OFFERS_ERR,
  CHANGE_PATH,
  UPDATE_FILTER,
};

/* Actions */
type ChangePath = (path: string) => {
  type: typeof CHANGE_PATH;
  path: string;
};

type OffersERR = (
  request: RequestState,
  error: Error,
) => {
  type: typeof types.OFFERS_ERR;
  request: RequestState;
  error: Error;
};

type OffersOK = (
  offers: Offer[],
  request: RequestState,
) => {
  type: typeof types.OFFERS_OK;
  offers: Offer[];
  request: RequestState;
};

type RequestOffers = (
  chainId: string,
  options?: RequestOptions,
) => {
  type: typeof types.REQUEST_OFFERS;
  options: RequestOptions;
  chainId: string;
};

type UpdateFilter = (
  filter: keyof State['filters'],
  value: any,
) => {
  type: typeof UPDATE_FILTER;
  filter: keyof State['filters'];
  value: any;
};

export type Action =
  | ReturnType<ChangePath>
  | ReturnType<OffersERR>
  | ReturnType<OffersOK>
  | ReturnType<RequestOffers>
  | ReturnType<UpdateFilter>;

export type ActionCreators = {
  ChangePath: ChangePath;
  OffersERR: OffersERR;
  OffersOK: OffersOK;
  RequestOffers: RequestOffers;
  UpdateFilter: UpdateFilter;
};

type Offer = {
  id: string;
  name: string;
  title: string;
  combindMarketingContent?: string;
  category: string;
  description: string;
  discontinued: boolean;
  fulfilled: number;
  publishAt: string | null;
  expireAt: string | null;
};

export type State = Readonly<{
  data: {
    offers: Offer[];
  };
  requests: {
    offers: RequestState;
  };
  paths: {
    offers?: string;
  };
  filters: {
    search: string;
    publicationStatus: 'all' | 'unpublished' | 'published' | 'expired';
    discontinued: 'true' | 'false';
  };
}>;

export default types;
